/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { logger } from '~/utils/sentry/client-only-logger'
import { analytics } from './segment-analytics'
import { withPrefix, getAppEventParams } from './utils'
import type { AppTrackingData } from '~/types/tracking'

const trackAppConnectButtonClick = (params: AppTrackingData) => {
  const eventParams = getAppEventParams(params)

  analytics
    .track(withPrefix(`App connect button clicked`), eventParams)
    .catch((e: unknown) => {
      logger.error(e)
    })
}

export const useTrackAppConnectButtonClick = (params: Prettify<AppTrackingData>) => clientOnly(() => {
  trackAppConnectButtonClick(params)
})
